import * as React from 'react';
import {
  FrontPageHeader as FrontPageHeaderComponent,
  FrontPageHeaderProps,
  DynamicFrontPageHeaderProps
} from '../../../components/modules/navigation/menuFrontPage';
import {notEmpty} from '../utils';
import {transformHrefAndName, HeaderProps} from '.';
import {SocialMediaTypes} from '../../../components/modules/socialMedia/widget';
import {SubscriptionOverlay} from '../../../components/modules/subscription-overlay';
import {Maybe} from '../../../lib/queryTypes';
import {useTranslation} from '../../../context/translation';

export type FrontPageHeaderDynamicProps = HeaderProps &
  DynamicFrontPageHeaderProps & {formData?: Maybe<string>};

const transformFrontPageHeaderProps = (
  dynamicProps: FrontPageHeaderDynamicProps
): Omit<FrontPageHeaderProps, 'onSubscriptionOverlayOpen'> => {
  const {data: header, isSearchPage, isHighlighted, locationPath, formData} = dynamicProps;

  return {
    socialMediaLinks: (header?.data?.socials ?? []).filter(notEmpty).map((social: any) => ({
      type: social.type as SocialMediaTypes,
      title: social.title ?? '',
      href: social.href ?? ''
    })),
    menuItems: header?.data?.items?.filter(notEmpty).map(transformHrefAndName) ?? [],
    locationPath,
    isSearchPage,
    isHighlighted,
    hasSubscriptionForm: !!formData
  };
};

const FrontPageHeader: React.FC<FrontPageHeaderDynamicProps> = props => {
  const {t} = useTranslation();
  const formData = props.formData ? JSON.parse(props.formData!) : null;
  const [isSubscriptionOverlayOpen, setIsSubscriptionOverlayOpen] = React.useState(false);

  return (
    <>
      <FrontPageHeaderComponent
        {...transformFrontPageHeaderProps(props)}
        onSubscriptionOverlayOpen={() => setIsSubscriptionOverlayOpen(true)}
      />
      {isSubscriptionOverlayOpen && formData && (
        <SubscriptionOverlay
          id="header-subscription-form"
          isOpen={isSubscriptionOverlayOpen}
          onClose={() => setIsSubscriptionOverlayOpen(false)}
          formData={formData}
          successTitle={t('front-page.subscribe-overlay.success-message')}
          regularTitle={t('front-page.subscribe-overlay.title')}
          backLinkLabel={t('front-page.subscribe-overlay.backlink-label')}
          buttonLabel={t('front-page.home.subscribe-button-label')}
          inputPlaceholder={t('front-page.subscribe-overlay.input-placeholder')}
        />
      )}
    </>
  );
};

export default FrontPageHeader;
